module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338600/particular03-cf3247d12d9c9f8424b979f4ae06f76d.png";